module.exports = __webpack_public_path__ + "img/软件著作权登记证书（25）.6262a749.png";